const reasons = [
  {
    icon: "ri-route-line",
    title: "Beginner-Friendly Pathways",
    desc: "No prior trading experience required. Our curriculum starts from the ground up, ensuring every learner has a clear, supported path forward.",
  },
  {
    icon: "ri-earth-line",
    title: "Cross-Border Perspective",
    desc: "We bring a global market lens to African and diaspora investors, connecting local learning with international financial contexts.",
  },
  {
    icon: "ri-medal-line",
    title: "Professional & Disciplined Approach",
    desc: "Our programs are built on rigor, not hype. We prioritize long-term financial education over short-term excitement.",
  },
  {
    icon: "ri-heart-line",
    title: "Community-Centered Education",
    desc: "Learn alongside a network of peers who share your background, ambitions, and commitment to building lasting financial knowledge.",
  },
  {
    icon: "ri-group-2-line",
    title: "Designed for African & Diaspora Audiences",
    desc: "Our content, context, and community are intentionally built to reflect and serve the African Diaspora experience.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Built on Trust, Structure & Credibility",
    desc: "Backed by Harambee Global Ventures and 7 Hills Development Group LLC, our academy operates with institutional-grade integrity.",
  },
];

export default function WhyChooseUs() {
  return (
    <section className="py-24 px-6 bg-[#F8F6F3]">
      <div className="max-w-[1280px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        {/* Content */}
        <div>
          <span className="inline-flex items-center gap-2 text-[#C9A961] text-xs font-semibold uppercase tracking-[0.25em] mb-5">
            <span className="w-8 h-px bg-[#C9A961]" />
            Why Harambee Academy
          </span>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-[#2B2D2F] leading-tight mb-6">
            Why Choose This Academy
          </h2>
          <p className="text-[#6B6B6B] text-base leading-relaxed mb-10">
            There are many places to learn about trading. What sets Harambee apart is our unwavering commitment to credibility, community, and the long-term financial empowerment of the African Diaspora.
          </p>

          <div className="space-y-6">
            {reasons.map((r) => (
              <div key={r.title} className="flex items-start gap-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#1A4D3C]/10 flex-shrink-0 mt-0.5">
                  <i className={`${r.icon} text-[#1A4D3C] text-lg`} />
                </div>
                <div>
                  <h3 className="font-semibold text-[#2B2D2F] text-sm mb-1">{r.title}</h3>
                  <p className="text-[#6B6B6B] text-sm leading-relaxed">{r.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Image */}
        <div className="relative">
          <img
            src="/assets/images/site/acad-why-001-700x800.jpg"
            alt="Why choose Harambee Trading Academy futures trading education Africa"
            className="w-full h-[580px] object-cover object-top rounded-lg"
          />
          {/* Accent card */}
          <div className="absolute top-8 -left-6 bg-white rounded-lg p-5 max-w-[200px] hidden md:block border border-[#E8E4DC]">
            <div className="flex items-center gap-2 mb-2">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#1A4D3C]/10">
                <i className="ri-star-line text-[#C9A961] text-sm" />
              </div>
              <span className="text-xs font-semibold text-[#2B2D2F]">Trusted Platform</span>
            </div>
            <p className="text-[#6B6B6B] text-xs leading-relaxed">Backed by 7 Hills Development Group LLC with institutional integrity</p>
          </div>
        </div>
      </div>
    </section>
  );
}
